import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PlatformEnum } from '@panamax/app-state';
import { InventoryViewModel } from '../../../../../../../../models/inventory-view.model';
import { InventoryStatus } from '@usf/inventory-types';

@Component({
  selector: 'app-past-inventories',
  templateUrl: './past-inventories.component.html',
  styleUrls: ['../../../populate-inventory-common-styles.scss'],
})
export class PastInventoriesComponent {
  readonly PlatformEnum = PlatformEnum;
  readonly InventoryStatus = InventoryStatus;

  @Input() platform: PlatformEnum;
  @Input() inventories: InventoryViewModel[];
  @Output()
  selectInventoryEmitter: EventEmitter<InventoryViewModel> = new EventEmitter();
  @Output() searchInventoriesEmitter: EventEmitter<string> = new EventEmitter();

  searchKey = '';

  constructor() {}

  search() {
    this.searchInventoriesEmitter.emit(this.searchKey);
  }

  resetSearch() {
    this.searchKey = '';
    this.search();
  }

  onSelectInventory(selectedInventory: InventoryViewModel) {
    this.selectInventoryEmitter.emit(selectedInventory);
  }
}
